// ThreatBadge.jsx
const THREAT_STYLES = {
  Low: {
    text: "Low",
    className:
      "bg-success10 text-success100 border-[1.5px] rounded-full border-[#00C8511A] w-fit px-2 py-1",
  },
  Log: {
    text: "Info",
    className:
      "border-[#d3e8f1] text-[#0BA5EC] bg-[#F1F8FF] border-[1.5px] rounded-full w-fit px-2 py-1",
  },
  Medium: {
    text: "Medium",
    className:
      "border-cream100 text-brown100 border-[1.5px] rounded-full bg-[#FFBB331A] w-fit px-2 py-1",
  },
  High: {
    text: "High",
    className:
      "border-[#F973161A] text-[#E3650F] border-[1.5px] rounded-full bg-[#F973161A] w-fit px-2 py-1",
  },
  Critical: {
    text: "Critical",
    className:
      "bg-[#FF44441A] text-[#E12A5B] border-[1.5px] rounded-full border-[#FFC1C1] w-fit px-2 py-1",
  },
};

const ThreatBadge = ({ threat }) => {
  const threatConfig = THREAT_STYLES[threat] || null;
  return <p className={threatConfig.className}>{threatConfig.text}</p>;
};

export default ThreatBadge;
